import { tv } from '@/utils/libs/tailwind-variants';
/**
 * BannerProMyPageListItem のスタイル
 */
export const bannerProMypageListItemStyle = tv({
    slots: {
        item: ['w-full hover:opacity-80'],
        thumbnail: ['w-full h-auto object-contain'],
    },
});
